import { StyleSheet } from '@react-pdf/renderer';

/** Convert millimetres to PDF points (1pt = 1/72in). react-pdf sizing uses points. */
export const mm = (value: number): number => (value * 72) / 25.4;

/** Physical size shared by every label document. */
export const LABEL_SIZE = { width: mm(90), height: mm(55) } as const;

/** Preserved-space helper: value, or "-" when empty/nullish — the slot always stays. */
export const dash = (value: unknown): string => {
  if (value === null || value === undefined) return '-';
  const s = String(value).trim();
  return s.length > 0 ? s : '-';
};

export const labelStyles = StyleSheet.create({
  page: { flexDirection: 'row', padding: mm(3), alignItems: 'center' },
  qr: { width: mm(44), height: mm(44), marginRight: mm(3) },
  info: { flex: 1, justifyContent: 'center' },
  title: { fontSize: 11, fontFamily: 'Helvetica-Bold', marginBottom: mm(1.5), textAlign: 'center' },
  line: { fontSize: 8, marginBottom: mm(1), textAlign: 'center' },
  gap: { height: mm(2) },
});
